import { render, staticRenderFns } from "./catalogue-item-redeem.vue?vue&type=template&id=c947242e&scoped=true"
import script from "./catalogue-item-redeem.vue?vue&type=script&lang=js"
export * from "./catalogue-item-redeem.vue?vue&type=script&lang=js"
import style0 from "./catalogue-item-redeem.vue?vue&type=style&index=0&id=c947242e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c947242e",
  null
  
)

export default component.exports